import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteMyAccount } from '@/api/user/deviceTokenService'
import { clearAuthTokens } from '@/lib/native'

export function useDeleteMyAccount() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteMyAccount,
    onSuccess: async () => {
      await clearAuthTokens()
      queryClient.clear()
    },
  })
}
